import { render, staticRenderFns } from "./VipFileDown.vue?vue&type=template&id=233f9cb3"
import script from "./VipFileDown.vue?vue&type=script&lang=js"
export * from "./VipFileDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports